var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Tooltip, theme } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useWatch } from 'react-hook-form';
import { useEventComposerGlobalContext } from '../../../composers/EventComposerGlobalContext';
import { canRemoveSpace, isSpaceChangePending as isSpaceChangePendingSelector, } from '../../../utils/spaceOrchestration';
var actionButtonStyle = {
    width: '100%',
    alignSelf: 'flex-start',
};
/**
 * Remove/Change act on the form only, so neither needs a confirmation.
 * In EDIT mode, removed spaces are declined on the server when the event
 * is saved (see declineRemovedSpaces in EditEventContext).
 *
 * The organizer space is the exception: removing it would effectively cancel
 * the event, so Remove is disabled for it — and for the replacement recorded
 * by a pending organizer move, since the event must keep an organizer space.
 * Changing it is allowed and is committed via /move at Save.
 */
export var useSpaceActions = function (_a) {
    var spaceId = _a.spaceId, spaceInviteeId = _a.spaceInviteeId, onChangeSpace = _a.onChangeSpace, userCanRemoveSpace = _a.userCanRemoveSpace;
    var tSpaceBooking = useTranslation('spaceBooking').t;
    var token = theme.useToken().token;
    var _b = useEventComposerGlobalContext(), spacesState = _b.spacesState, initialSpaces = _b.initialSpaces, removeSpace = _b.removeSpace;
    var formSpaces = useWatch({
        name: 'spaces',
    });
    var removeDisabled = !canRemoveSpace(spacesState, initialSpaces, formSpaces, spaceId).allowed;
    var isSpaceChangePending = isSpaceChangePendingSelector(spacesState, spaceId);
    return useMemo(function () {
        if (!userCanRemoveSpace)
            return [];
        return [
            _jsx(Button, { variant: "outlined", type: "text", size: "small", onClick: function () { return onChangeSpace(spaceId, spaceInviteeId); }, style: actionButtonStyle, disabled: !!isSpaceChangePending, loading: isSpaceChangePending, children: isSpaceChangePending
                    ? tSpaceBooking('change_space.changing_space')
                    : tSpaceBooking('change_space.action') }, "change"),
            _jsx(Tooltip, { title: removeDisabled
                    ? tSpaceBooking('remove_space.organizer_space_tooltip')
                    : null, children: _jsx(Button, { variant: "outlined", type: "text", size: "small", onClick: function () { return removeSpace(spaceId); }, style: __assign(__assign({}, actionButtonStyle), (removeDisabled ? {} : { color: token.colorError })), disabled: removeDisabled, children: tSpaceBooking('remove_space.action') }) }, "remove"),
        ];
    }, [
        userCanRemoveSpace,
        isSpaceChangePending,
        removeDisabled,
        onChangeSpace,
        removeSpace,
        spaceId,
        spaceInviteeId,
        tSpaceBooking,
        token.colorError,
    ]);
};
